import { render } from "./SurroundingsTab.vue?vue&type=template&id=9f57b7ba&scoped=true"
import script from "./SurroundingsTab.vue?vue&type=script&lang=js"
export * from "./SurroundingsTab.vue?vue&type=script&lang=js"

import "./SurroundingsTab.vue?vue&type=style&index=0&id=9f57b7ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f57b7ba"]])

export default __exports__